export class ListFilter {
    constructor(p: number, col: string, dir: string) {
        this.page = 1;
        this.pageSize = p;
        this.sortedColumn = col;
        this.sortedDirection = dir;
    }

    page: number;
    pageSize: number;
    sortedColumn: string;
    sortedDirection: string;

    public showing(ct: number | undefined, item: string | null = null): string {
        if (!ct) {
            return `Showing 0 ${item || 'results'}`;
        }
        return `Showing ${(((this.page - 1) * this.pageSize) + 1)}-${(Math.min(ct, this.page * this.pageSize))} of ${ct} ${item || 'results'}`;
    }

}